export default "__VITE_ASSET__COILQ4GU__"